import { db } from "../../../mp-database"
import parseSnapshot from "../../../mp-utils/generic-utils/common/parseSnapshot"

export default function updateStudentLessonsByClass(
  classKey,
  userId,
  notInClass
) {
  return getStudentLessonsByClassId(classKey)
    .then(querySnapshot => {
      var userLessonsGrouped = parseSnapshot(querySnapshot)
      Object.entries(userLessonsGrouped).forEach(
        ([lessonGroupId, lessonGroup]) => {
          let lessonId = lessonGroup.lessonId
            ? lessonGroup.lessonId
            : lessonGroupId.replace(`CLASS_${lessonGroup.groupId}_`, "")
          let userLessonId = `${userId}_${lessonId}`

          //Only update locked or unlocked lessons don't update  lessons having status REVIEW or something else
          db.collection("lessons_students")
            .where("status", "==", !!notInClass ? "LOCKED" : "UNLOCKED")
            .where("id", "==", userLessonId)
            .get()
            .then(querySnapshot => {
              if (querySnapshot.size) {
                var data = parseSnapshot(querySnapshot)
                if (data[userLessonId]) {
                  var lesson = data[userLessonId]

                  if (!lesson.deleted) {
                    //Toggle status of old record
                    if (lesson.status == "LOCKED") {
                      //Unlocked
                      toggleStudentLessonStatus(userLessonId, "UNLOCKED")
                    }

                    //Check if user lesson is already unlocked in another class
                    //then don't lock the class other wise lock lesson for the current student
                    if (lesson.status == "UNLOCKED") {
                      if (lesson.classIds) {
                        var classIds = Object.keys(lesson.classIds).filter(
                          classId => lesson.classIds[classId]
                        )
                        var promisesListLessonCount = []
                        classIds.forEach(classId => {
                          var _lessonGroupId = `CLASS_${classId}_${lesson.lessonId}`
                          promisesListLessonCount.push(
                            getGroupLockedLessonDoc(_lessonGroupId)
                          )
                        })

                        Promise.all(promisesListLessonCount).then(
                          querySnapshotList => {
                            var unlockedLessonsInOtherClasses = 0
                            querySnapshotList.forEach(__querySnap => {
                              unlockedLessonsInOtherClasses += __querySnap.size
                            })
                            //If lesson is not unlocked in other classes the lock it
                            if (!unlockedLessonsInOtherClasses) {
                              toggleStudentLessonStatus(userLessonId, "LOCKED")
                            }
                          }
                        )
                      }
                    }
                  }
                }
              }
            })
            .catch(errors => {
              console.log(errors)
            })
        }
      )
    })
    .catch(errors => {
      console.log(errors)
    })
}
function getGroupLockedLessonDoc(docId) {
  return db
    .collection("lessons_groups")
    .where("locked", "==", false)
    .where("id", "==", docId)
    .get()
}

function getStudentLessonsByClassId(classId, groupType = "Class") {
  return new Promise((resolve, reject) => {
    db.collection("lessons_groups")
      .where("classId", "==", classId.replace("classIds.", ""))
      .where("groupType", "==", groupType)
      .where("locked", "==", false)
      .get()
      .then(querySnapshot => {
        resolve(querySnapshot)
      })
      .catch(errors => {
        reject(errors)
      })
  })
}

function toggleStudentLessonStatus(id, status) {
  db.collection("lessons_students")
    .doc(id)
    .update({
      ["status"]: status
    })
    .catch(errors => {})
}
